__turbopack_context__.v({
  "iframeWrapper": "ReportEventIframeModal-module-scss-module__CNnH3a__iframeWrapper",
  "modalContainer": "ReportEventIframeModal-module-scss-module__CNnH3a__modalContainer",
  "reportEventIframe": "ReportEventIframeModal-module-scss-module__CNnH3a__reportEventIframe",
});
